/**
 * Зураггүй / эвдэрсэн арга хэмжээнд — өөр өөр cover (Unsplash).
 * Ижил seed → ижил зураг (SSR/CSR зөрөхгүй).
 */
const EVENT_FALLBACK_IMAGES = [
  "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1523580494863-6f303122a4cd?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1544531586-fde5298cdd40?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1560439514-4dc1646bc7e8?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1591115765373-5207764f72e7?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1464375117522-1311d6a5b81f?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1515187029135-18ee286d815b?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1600&q=80",
];

function hashToIndex(seed, modulo) {
  const s = seed != null && String(seed).length > 0 ? String(seed) : "event";
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % modulo;
}

/** Зураггүй үед: арга хэмжээ бүрт тогтвортой өөр зураг */
export function pickEventFallbackImage(seed) {
  return EVENT_FALLBACK_IMAGES[hashToIndex(seed, EVENT_FALLBACK_IMAGES.length)];
}

/** Анхны URL ачаалагдахгүй үед өөр сонголт */
export function pickEventFallbackImageAlt(seed) {
  return EVENT_FALLBACK_IMAGES[hashToIndex(`${seed ?? ""}|alt`, EVENT_FALLBACK_IMAGES.length)];
}

/** Хуучин импорттой нийцэх */
export const DEFAULT_EVENT_IMAGE_URL = EVENT_FALLBACK_IMAGES[0];

/**
 * @param {string|null|undefined} raw — DB imageUrl / legacy event.image
 * @param {string} baseUrl — API/static суурь
 * @param {string|null|undefined} fallbackSeed — зураггүй үед (жишээ нь event.id)
 */
export function resolveEventImage(raw, baseUrl, fallbackSeed) {
  const t = raw != null ? String(raw).trim() : "";
  if (!t) return pickEventFallbackImage(fallbackSeed);
  if (/^data:/i.test(t)) return t;
  // Legacy/malformed value: "http://host/data:image/..."
  if (/^https?:\/\/[^/]+\/data:image\//i.test(t)) {
    return t.replace(/^https?:\/\/[^/]+\//i, "");
  }
  if (/^https?:\/\//i.test(t)) return t;
  const base = (baseUrl || "").replace(/\/+$/, "");
  const path = t.startsWith("/") ? t : `/${t}`;
  return base ? `${base}${path}` : path;
}
